module.exports = __webpack_public_path__ + "static/media/ethos.e9ccad6f.png";